import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Stack,
} from "@mui/material";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";

const ModalDeEstamosTrabajando = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Estamos trabajando en esta funcionalidad</DialogTitle>

      <DialogContent>
        <Stack spacing={2} alignItems="center" sx={{ py: 2 }}>
          <ConstructionRoundedIcon
            sx={{
              fontSize: 70,
              color: "warning.main",
            }}
          />

          <Typography align="center">
            Esta funcionalidad todavía se encuentra en desarrollo.
          </Typography>

          <Typography variant="body2" color="text.secondary" align="center">
            Nuestro equipo está trabajando para ponerla a disposición lo antes
            posible. Agradecemos tu paciencia y comprensión.
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" fullWidth>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDeEstamosTrabajando;
